import React, { useEffect, useState } from 'react';
import Header from '../components/header';
import CustomSelect from '../../components/customSelect';
import Calendar from './components/calendar';
import TimesSelect from './components/timesSelect';
import { useSelector } from 'react-redux';
import { configSelector } from '../../store/configSlice';
import CustomButton from '../../components/customButton';
import axios from 'axios';
import getEnvironement from '../../environnement';
import { toast, ToastContainer } from 'react-toastify';
import CustomBackdrop from '../../components/backdrop';
import { userSelector } from '../../store/userSlice';
import { useNavigate } from 'react-router-dom';

export default function Calendrier() {
  const [reservationYear, setReservationYear] = useState(new Date().getFullYear());
  const [reservationMonth, setReservationMonth] = useState(getMonthName(new Date().getMonth()));
  const [reservationDay, setReservationDay] = useState('');
  const [selectedTimes, setSelectedTimes] = useState([]);

  const [reservationYearError, setReservationYearError] = useState('');
  const [reservationMonthError, setReservationMonthError] = useState('');
  const [reservationDayError, setReservationDayError] = useState('');
  const [selectedTimesError, setSelectedTimesError] = useState('');

  const [badgeNotification, setBadgeNotification] = useState(0);
  const [reservationsNotification, setReservationsNotification] = useState([]);
  const [messagesNotification, setMessagesNotification] = useState([]);

  const [desactivatedDates, setDesactivatedDates] = useState([]);

  const [disabledPeriodes, setDisabledPeriodes] = useState([]);
  const [openBackdrop, setOpenBackDrop] = useState(false);

  const [isLoader, setIsLoader] = useState(false);

  const config = useSelector(configSelector);
  const user = useSelector(userSelector);
  const navigate = useNavigate();

  const mois = [
    'Janvier', 'Février', 'Mars', "Avril", 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ];

  function getMonthName(monthNumber) {
    const monthNames = [
        "Janvier", "Février", "Mars", "Avril", "Mai", "Juin",
        "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"
    ];

    return monthNames[monthNumber];
  }

  function getRange(n) {
    const result = [];
    for (let i = 1; i <= n; i++) {
      result.push(i);
    }
    return result;
  }

  function getPastDays(year, month) {
    const today = new Date();

    if (today.getFullYear() > year) {
      return getRange(new Date(year, month, 0).getDate());
    
    } else if (today.getFullYear() === parseInt(year) && today.getMonth() + 1 > month) {
      return getRange(new Date(year, month, 0).getDate());
    
    } else if (today.getFullYear() === parseInt(year) && today.getMonth() + 1 === month) {
      const currentDay = today.getDate();
      const pastDays = [];
      for (let i = 1; i < currentDay; i++) {
        pastDays.push(i);
      }

      return pastDays;
    
    } else {
      return [];
    }
  }

  function mergeArrays(arr1, arr2) {
    const mergedArray = arr1.concat(arr2);
    return [...new Set(mergedArray)];
  }

  function getMonthNumber(month) {
    const months = {
      'Janvier': 1,
      'Février': 2,
      'Mars': 3,
      'Avril': 4,
      'Mai': 5,
      'Juin': 6,
      'Juillet': 7,
      'Août': 8,
      'Septembre': 9,
      'Octobre': 10,
      'Novembre': 11,
      'Décembre': 12,
    };
  
    return months[month];
  }

  function getDatesInMonth(month, year, dates) {
    const monthNumber = getMonthNumber(month);
  
    const resultDays = dates
      .map((date) => {
        const currentDate = new Date(date);
        if (currentDate.getFullYear() === parseInt(year) && currentDate.getMonth() + 1 === monthNumber) {
          return currentDate.getDate();
        }
        return null;
      })
      .filter(index => index !== null);
      
    const pastDays = getPastDays(year, monthNumber);
    
    const result = mergeArrays(pastDays, resultDays);

    return result;
  }

  function getPeriodesByDate(data, year, month, day) {
    const newMonth = `${month}`.length === 1 ? `0${month}` : `${month}`;
    const newDay = `${day}`.length === 1 ? `0${day}` : `${day}`;
    const date = `${year}-${newMonth}-${newDay}`;
    
    return data.find((item) => item.date === date) ? data.find((item) => item.date === date).periodes : [];
  }

  async function getNotificationData() {
    const url = `${getEnvironement().API_URL}/notificationData`;
    await axios.post(url)
      .then((res) => {
        setReservationsNotification(res.data.reservations);
        setMessagesNotification(res.data.messages);
      })
      .then(() => setBadgeNotification(reservationsNotification.length + messagesNotification.length))
      .catch(() => {});
  }

  function getFormatedDate() {
    const year = reservationYear;
    const month = getMonthNumber(reservationMonth).toString().length === 1 ? `0${getMonthNumber(reservationMonth)}` : getMonthNumber(reservationMonth);
    const day = reservationDay.toString().length === 1 ? `0${reservationDay}` : reservationDay;
    
    const date = `${year}-${month}-${day}`;

    return date;
  }

  function getPeriodesListeByDate(reservationsData, date) {
    const liste = reservationsData[date];
    let periodes = [];
    if (liste) {
      for (let i = 0; i < liste.length; i++) {
        for (let j = 0; j < JSON.parse(liste[i].periodes).length; j++) {
          periodes.push(JSON.parse(liste[i].periodes)[j]);
        }
      }
    }

    return periodes
  }

  const timeExistsInList = (time, list) => {
    return list.includes(time);
  };

  const addItemToList = (item, list) => {
    return [...list, item];
  }

  const removeItemFromList = (item, list) => {
    return list.filter(i => i !== item);
  }

  async function getCalendarDateReservation()
  {
    const url = `${getEnvironement().API_URL}/getCalendarDateReservation`;
    setIsLoader(true);
    await axios.post(url)
      .then((res) => setDisabledPeriodes(getPeriodesListeByDate(res.data.disabledPeriodes, getFormatedDate())))
      .then(() => setIsLoader(false))
      .catch(() => setIsLoader(false));
  }

  async function getAdminDesactivatedDate()
  {
    const url = `${getEnvironement().API_URL}/getAdminDesactivatedDate`;
    await axios.post(url)
      .then((res) => {
        let desactivatedDate = [];
        Object.keys(res.data.adminDisabledPeriodes).forEach(date => {
          if (res.data.adminDisabledPeriodes[date][0].all_periodes === 1) {
            desactivatedDate.push(date);
          }
        });
        setDesactivatedDates(desactivatedDate);
        const periodes = getPeriodesListeByDate(res.data.adminDisabledPeriodes, getFormatedDate());
        setSelectedTimes(periodes);
      })
      .then(() => setIsLoader(false))
      .catch(() => setIsLoader(false));
  }

  async function updateDesactivatedDate() {
    const url = `${getEnvironement().API_URL}/updateDesactivatedDate`;
    const data = {
      date: getFormatedDate(),
      periodes: selectedTimes,
      allPeriodes: selectedTimes.length === 0 || selectedTimes.length === 12 ? 1 : 0,
    };
    const config = {
      headers: {
        'Content-Type': 'application/json'
      }
    };

    setOpenBackDrop(true);
    await axios.post(url, data, config)
      .then(() => {
        getCalendarDateReservation();
        getAdminDesactivatedDate();
      })
      .then(() => setTimeout(() => setOpenBackDrop(false), 800))
      .then(() => toast.success('les dates et périodes ont bien été modifiées'))
      .catch(() => {})
  }

  useEffect(() => {
    getCalendarDateReservation();
    getAdminDesactivatedDate();
  }, [reservationYear, reservationMonth, reservationDay]);

  useEffect(() => {
    setBadgeNotification(reservationsNotification.length + messagesNotification.length);
  }, [reservationsNotification, messagesNotification]);

  useEffect(() => {
    getNotificationData();
  }, []);

  useEffect(() => {
    if (user === null) {
      navigate('/admin');
    }
  }, [navigate, user]);

  return (
    <div className='h-screen flex flex-col'>
      <ToastContainer />
      <CustomBackdrop open={openBackdrop} setOpen={setOpenBackDrop} />
      <Header
        activeItem='Calendrier'
        reservations={reservationsNotification}
        messages={messagesNotification}
        badgeNotification={badgeNotification}
      />
      <div className='w-full 3xl:flex 3xl:justify-center flex-grow'>
        <div className='3xl:w-[1200px] px-10 pt-5 3xl:py-5 3xl:px-0 h-full flex flex-col justify-center'>
          <p className='font-inter text-primary font-medium text-2xl sm:text-3xl mb-6'>Calendrier:</p>
          <div className='mb-10 w-full'>
            <div className='flex justify-between gap-5'>
              <div className='w-full'>
                <CustomSelect
                  placeholder='Année'
                  value={reservationYear}
                  setValue={setReservationYear}
                  items={[
                    {id: 1, value: new Date().getFullYear(), label: new Date().getFullYear()},
                    {id: 2, value: new Date().getFullYear() + 1, label: new Date().getFullYear() + 1}
                  ]}
                  isError={reservationYearError !== ''}
                  error={reservationYearError}
                />
              </div>
              <div className='w-full'>
                <CustomSelect
                  placeholder='Mois'
                  value={reservationMonth}
                  setValue={setReservationMonth}
                  items={mois.map((item, index) => {
                    return {id: index, value: getMonthName(index), label: item}
                  })}
                  isError={reservationMonthError !== ''}
                  error={reservationMonthError}
                />
              </div>
            </div>
            <div className='flex flex-col xl:flex-row xl:justify-between gap-5 w-full mb-5'>
              <Calendar
                numberOfDays={new Date(reservationYear, getMonthNumber(reservationMonth), 0).getDate()}
                disabledList={getDatesInMonth(reservationMonth, reservationYear, config['desactivated_date'].filter((item) => item['all_periodes'] === 1).map((item) => item.date))}
                desactivatedDates={desactivatedDates.map((item) => parseInt(item.split('-')[2]))}
                selectedDay={reservationDay}
                setSelectedDay={setReservationDay}
                isError={reservationDayError !== ''}
                error={reservationDayError}
              />
              <div className='flex-grow'>
                <TimesSelect
                  times={[
                    '09:00 - 09:30',
                    '09:30 - 10:00',
                    '10:00 - 10:30',
                    '10:30 - 11:00',
                    '11:00 - 11:30',
                    '11:30 - 12:00',
                    '12:00 - 12:30',
                    '12:30 - 13:00',
                    '13:00 - 13:30',
                    '13:30 - 14:00',
                    '14:00 - 14:30',
                    '14:30 - 15:00',
                  ]}
                  disabledList={disabledPeriodes}
                  isHidden={reservationDay === ''}
                  isLoader={isLoader}
                  selectedTimes={selectedTimes}
                  setSelectedTimes={setSelectedTimes}
                  isError={selectedTimesError !== ''}
                  error={selectedTimesError}
                />
              </div>
            </div>
            <div
              className='group rounded-[20px] py-3 w-full cursor-pointer bg-primary hover:bg-primaryDark'
              onClick={() => {
                if (reservationDay === '') {
                  toast.error('Merci de sélectionner une date valide');
                } else {
                  updateDesactivatedDate();
                }
              }}
            >
              <p className='font-medium text-2xl sm:text-3xl w-full text-center text-white'>Activer / Désactiver</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
